<template>
  <div class="logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <path
        d="M29.1794 3.91162L19.7966 10.7287L35.5181 22.1512C35.8327 20.8207 36 19.4339 36 18.0087C36 12.3043 33.3322 7.21181 29.1794 3.91162Z"
        fill="currentColor"
      />
      <path
        d="M27.3505 2.63313C24.6236 0.968622 21.4218 0.00857544 18 0.00857544C14.3225 0.00857544 10.8997 1.11797 8.04694 3.01844L11.6326 14.053L27.3505 2.63313Z"
        fill="currentColor"
      />
      <path
        d="M6.26773 4.36865C2.43246 7.67214 0 12.5615 0 18.0086C0 19.6824 0.230484 21.3031 0.659883 22.8418H12.2705L6.26773 4.36865Z"
        fill="currentColor"
      />
      <path
        d="M1.39337 24.9512C4.02313 31.218 10.1005 35.6931 17.2393 35.9914L20.8265 24.9512H1.39337Z"
        fill="currentColor"
      />
      <path
        d="M19.4713 35.9481C26.5481 35.3729 32.4799 30.6867 34.8695 24.2871L25.4773 17.4633L19.4713 35.9481Z"
        fill="currentColor"
      />
    </svg>
    <h1>Tempest<span>.</span></h1>
  </div>
</template>

<style scoped>
  h1,
  h1 span,
  svg {
    display: inline;
  }
  h1,
  h1 span {
    color: var(--text);
    font-weight: 700;
    font-size: 3rem;
    user-select: none;
  }
  h1 span {
    color: var(--accent);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  svg {
    margin-top: 0.3rem;
    margin-right: 0.6rem;
    width: 2.4rem;
    height: 2.4rem;
    color: var(--text);
  }
  div.logo {
    display: flex;
    align-items: center;
  }
</style>
